const advantagesSection = $('.advantages-section');
const advantagesStickyMain = advantagesSection.find('.advantages-sticky-main');
const sceneTitle = $('.advantages-title');
const advantagesBtn = advantagesSection.find('.button-parent');
const descriptorCards = advantagesSection.find('.descriptor-image-card');
const titleOffset = pxToVw(sceneTitle.width() - $(window).width() + 60);
const sceneEasing = CustomEase.create('sceneEasing', '0.5, 0.25, 0.5, 0.75');
const cardEasing = CustomEase.create('cardEasing', '0.0, 0.5, 1.0, 0.5');
const titleEasing = CustomEase.create('titleEasing', '0.59, 0.22, 0.494, 0.603');
const innerEasing = CustomEase.create('innerEasing', '0.25, 0.75, 0.75, 1.0');
const lineAspect = isLowEndDevice ? 170 : 100;

const framesCount = 600;
let btnIsHidden = true;
let drawAdvantagesFrame;
let advantagesadvantagesVideoEl;
let isAdvantagesSequenceInitialized = false;
let isAdvantagesAnimationInitialized = false;

const syncAdvantagesGradientPlayback = (isVisible) => {
  if (typeof window.setGradientConsumerState === 'function') {
    window.setGradientConsumerState('advantages', isVisible);
  }
};

const observeAdvantagesGradientPlayback = () => {
  if (!advantagesSection.length) return;

  const advantagesNode = advantagesSection.get(0);
  const updateVisibility = (isVisible) => {
    syncAdvantagesGradientPlayback(isVisible);
  };

  updateVisibility(
    advantagesNode.getBoundingClientRect().bottom > 0 &&
      advantagesNode.getBoundingClientRect().top < window.innerHeight
  );

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => updateVisibility(entry.isIntersecting));
    },
    {
      threshold: 0.01,
    }
  );

  observer.observe(advantagesNode);
};


const btnTL = addBtnAnimation(advantagesBtn);

const animateBtn = (progress) => {
  const startFrame = 525;
  const startProgress = startFrame / framesCount;
  if (progress >= startProgress && btnIsHidden) {
    btnTL.play();
    btnIsHidden = false;
  }
};

const animateSceneTitle = (progress) => {
  const titleEndFrame = 60;
  let titleProgress = (progress * framesCount) / titleEndFrame;
  titleProgress = Math.min(Math.max(titleProgress, 0), 1);
  const easedProgress = titleEasing(titleProgress);
  gsap.set(sceneTitle, {
    x: `-${titleOffset * easedProgress}vw`,
  });
};

const animateCardsFraming = (progress) => {
  const cardFrameDuration = 75;
  const innerFrameOffset = 4;
  const innerFrameDuration = 8;
  const cardsFramesTiming = [70, 145, 220, 295, 370, 445];
  cardsFramesTiming.forEach((startFrame, index) => {
    const currentCard = descriptorCards.eq(index);
    const currentCardInner = currentCard.find(' > *:not(.descriptor-image-line)');
    const currentCardLine = currentCard.find('.descriptor-image-line');

    const animateCardMove = () => {
      const maxOffset = 100 + pxToVh(currentCard.outerHeight());
      const cardStartProgress = startFrame / framesCount;
      const cardEndProgress = (startFrame + cardFrameDuration) / framesCount;
      let cardProgress = (progress - cardStartProgress) / (cardEndProgress - cardStartProgress);
      cardProgress = Math.max(0, Math.min(1, cardProgress));
      const easedProgress = cardEasing(cardProgress);
      const offset = maxOffset * easedProgress;
      gsap.set(currentCard, {
        y: `-${offset}vh`,
      });
    };

    const animateCardInner = () => {
      const innerStartProgress = (startFrame + innerFrameOffset) / framesCount;
      const innerEndProgress = (startFrame + innerFrameOffset + innerFrameDuration) / framesCount;
      let innerProgress = (progress - innerStartProgress) / (innerEndProgress - innerStartProgress);
      innerProgress = Math.max(0, Math.min(1, innerProgress));
      const easedProgress = innerEasing(innerProgress);
      gsap.set(currentCardLine, {
        scaleX: `${easedProgress}`,
        transformOrigin: 'center left',
      });
      gsap.set(currentCardInner, {
        opacity: easedProgress,
        y: `${1 - easedProgress}vw`,
      });
    };

    animateCardMove();
    animateCardInner();
  });
};

const linesData = {
  linesParent: undefined,
  linesObjs: [],
  progressCoeff: undefined,
  parentHeight: undefined,
};

const setSceneLinesOffsets = (progress) => {
  linesData.linesObjs.forEach(function (linesObj) {
    linesObj.linesInner.forEach(function (lineObj) {
      const currentOffset = lineObj.offset + progress * linesData.parentHeight * 1.4;
      gsap.set(lineObj.mask, {
        y: `${currentOffset}`,
      });
      gsap.set(lineObj.line, {
        y: `${-currentOffset}`,
      });
    });
  });
};

const setSceneLines = () => {
  const linesParents = $('.line-parent');
  linesData.linesParent = $('.advantages-lines');
  linesData.parentHeight = linesData.linesParent.outerHeight();
  const maskHeight = -linesData.parentHeight * 0.1077;
  const maskOffset = -linesData.parentHeight * 0.4307;
  linesParents.each(function (i) {
    const lineMask = $(this).find('.line-mask');
    linesData.linesObjs.push({
      parent: $(this),
      linesInner: [],
    });
    lineMask.each(function (j) {
      const lineSVG = $(this).find('.svg-line');
      const parentOffset = i * maskHeight;
      const offset = parentOffset + j * maskOffset;
      linesData.linesObjs[i].linesInner.push({
        line: lineSVG,
        mask: $(this),
        offset: offset,
      });
    });
  });
  linesData.progressCoeff =
    (linesData.linesObjs[0].linesInner[0].line.height() + 1.3 * $('.advantages-lines-sticky').height()) /
    $('.advantages-lines-placer').height();
  setSceneLinesOffsets(0);
};

const animateSceneLines = (progress) => {
  gsap.set(linesData.linesParent, {
    y: `-${progress * linesData.progressCoeff * lineAspect}%`,
  });
  setSceneLinesOffsets(progress);
};



const advantagesScene = advantagesSection.find('.advantages-scene').get(0);
const addSequenceAnimation = () => {
  const frameData = { frame: 0 };
  let lastframe = 0;

  const blobFraming = {
    blob1: {
      position: {
        frames: [
          { frame: 0, value: [-0.5, 0.5] },
          { frame: 100, value: [-0.1, 1.1] },
          { frame: 150, value: [-0.1, 1.1] },
          { frame: 280, value: [0.3, -0.2] },
          { frame: 280, value: [-0.2, 1.2] },
          { frame: 310, value: [0.1, 1.05] },
          { frame: 355, value: [0.5, 1.25] },
          { frame: 400, value: [0.9, 1.05] },
        ],
      },
      size: {
        frames: [
          { frame: 0, value: 0.4 },
          { frame: 100, value: 0.4 },
          { frame: 150, value: 0.4 },
          { frame: 280, value: 0.5 },
          { frame: 280, value: 0.4 },
        ],
      },
      scale: {
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        frames: [
          { frame: 0, value: 0.6 },
          { frame: 280, value: 0.6 },
          { frame: 310, value: 0.8 },
        ],
      },
      color: {
        frames: [
          { frame: 0, value: [0.051, 0.0666, 0.165, 1] },
          { frame: 100, value: [0.337, 0.494, 0.612, 1] },
          { frame: 150, value: [0.337, 0.494, 0.612, 1] },
          { frame: 280, value: [0.055, 0.141, 0.408, 1] },
          { frame: 280, value: [0.051, 0.0666, 0.165, 1] },
        ],
      },
    },
    blob2: {
      position: {
        frames: [
          { frame: 0, value: [1.1, -0.1] },
          { frame: 280, value: [1.1, -0.1] },
          { frame: 310, value: [1.1, -0.15] },
          { frame: 355, value: [0.6, -0.25] },
          { frame: 400, value: [0.1, -0.15] },
          { frame: 480, value: [-0.5, 0.6] },
          { frame: 530, value: [-0.5, 0.6] },
          { frame: 565, value: [0.1, 0.85] },
          { frame: 600, value: [0.5, 1.0] },
        ],
      },
      size: {
        frames: [
          { frame: 0, value: 0.3 },
          { frame: 280, value: 0.4 },
          { frame: 530, value: 0.4 },
          { frame: 565, value: 0.5 },
          { frame: 600, value: 0.5 },
        ],
      },
      scale: {
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        frames: [
          { frame: 0, value: 0.6 },
          { frame: 280, value: 0.6 },
          { frame: 310, value: 0.8 },
          { frame: 530, value: 0.8 },
          { frame: 565, value: 0.6 },
          { frame: 600, value: 0.8 },
        ],
      },
      color: {
        frames: [
          { frame: 0, value: [0.051, 0.0666, 0.165, 1] },
          { frame: 530, value: [0.051, 0.0666, 0.165, 1] },
          { frame: 530, value: [0.337, 0.494, 0.612, 1] },
          { frame: 600, value: [0.337, 0.494, 0.612, 1] },
        ],
      },
    },
    blob3: {
      position: {
        frames: [
          {
            frame: 0,
            value: [0.6, 0.6],
            path: {
              type: 'bezier',
              control: [0.769, 0.191, 1.0, 0.5],
            },
          },
          { frame: 100, value: [1.1, 0.8] },
          { frame: 150, value: [1.1, 0.5] },
          { frame: 225, value: [0.7, 0.7] },
          { frame: 280, value: [0.6, 0.6] },
          { frame: 410, value: [0.6, 0.6] },
          { frame: 445, value: [0.8, 0.7] },
          { frame: 480, value: [1.0, 0.6] },
          { frame: 500, value: [1.0, 0.5] },
          { frame: 560, value: [0.5, 1.0] },
        ],
      },
      size: {
        frames: [
          { frame: 0, value: 0.4 },
          { frame: 310, value: 0.4 },
          { frame: 380, value: 0.25 },
          { frame: 480, value: 0.4 },
        ],
      },
      scale: {
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        frames: [
          { frame: 0, value: 0 },
          { frame: 600, value: 0 },
        ],
      },
      smooth_step: {
        frames: [{ frame: 0, value: 0.7 }],
      },
      color: {
        frames: [{ frame: 0, value: [0.408, 0.588, 0.702, 1] }],
      },
    },
    blob4: {
      position: {
        frames: [
          { frame: 0, value: [0.4, 0.4] },
          { frame: 100, value: [1.1, 0.5] },
          { frame: 150, value: [1.1, 0.2] },
          { frame: 225, value: [0.7, 0.7] },
          { frame: 280, value: [0.4, 0.4] },
          { frame: 410, value: [0.4, 0.4] },
          { frame: 445, value: [0.8, 0.8] },
          { frame: 480, value: [1.0, 0.5] },
          { frame: 500, value: [1.0, 0.5] },
          { frame: 560, value: [0.5, 1.0] },
        ],
      },
      size: {
        frames: [
          { frame: 0, value: 0.4 },
          { frame: 310, value: 0.4 },
          { frame: 380, value: 0.25 },
          { frame: 480, value: 0.5 },
        ],
      },
      scale: {
        frames: [{ frame: 0, value: 1 }],
      },
      angle: {
        frames: [{ frame: 0, value: 0 }],
      },
      smooth_step: {
        frames: [
          { frame: 0, value: 0.8 },
          { frame: 380, value: 0.8 },
          { frame: 480, value: 0.9 },
        ],
      },
      color: {
        frames: [{ frame: 0, value: [0.408, 0.588, 0.702, 1] }],
      },
    },
  };

  setSceneLines();
  gsap.to(frameData, {
    frame: framesCount - 1,
    snap: 'frame',
    ease: 'sceneEasing',
    scrollTrigger: {
      trigger: '.advantages-section',
      start: 'top top',
      end: 'bottom bottom',
      scrub: 0.5,
      onUpdate: (self) => {
        const progress = sceneEasing(self.progress);
        if (isDesktop()) {
          animateSceneTitle(progress);
          animateSceneLines(progress);
        }
        animateCardsFraming(progress);
        animateBtn(progress);

        if (!isLowEndDevice) {
          const frame = Math.floor(self.progress * (framesCount - 1));
          if (frame !== lastframe) {
            lastframe = frame;
            drawAdvantagesFrame(frame);
          }
          gradientAPI.updateGradientSettingsByFrame(progress, blobFraming, framesCount);
        } else {
          if (advantagesadvantagesVideoEl && advantagesadvantagesVideoEl.duration) {
            advantagesadvantagesVideoEl.currentTime = progress * advantagesadvantagesVideoEl.duration;
          }
        }
      },
    },
  });
};

const initSquenceAnimation = () => {
  if (isAdvantagesSequenceInitialized) return;
  isAdvantagesSequenceInitialized = true;

  if (!isLowEndDevice) {
    const isDesktopDevice = isDesktop();

    ({ drawFrame: drawAdvantagesFrame } = initWebGLSequence(
      'scroll-sequence',
      framesCount,
      'https://cdn.jsdelivr.net/gh/eugene-activbody/activeforce_data/advantages_scene/fhd/scene_frame_',
      'avif',
      5,
      {
        preloadWindow: isDesktopDevice ? 18 : 14,
        initialPreloadCount: isDesktopDevice ? 36 : 22,
        enablePreview: true,
        maxResidentFrames: isDesktopDevice ? 200 : 130,
        maxConcurrent: isDesktopDevice ? 4 : 3,
      }
    ));
  } else {
    advantagesVideoEl = document.createElement('video');
    advantagesVideoEl.autoplay = false;
    advantagesVideoEl.loop = false;
    advantagesVideoEl.muted = true;
    advantagesVideoEl.playsInline = true;
    advantagesVideoEl.style.position = 'absolute';
    advantagesVideoEl.style.top = 0;
    advantagesVideoEl.style.left = 0;
    advantagesVideoEl.style.width = '100%';
    advantagesVideoEl.style.height = '100%';
    advantagesVideoEl.style.objectFit = 'cover';
    advantagesStickyMain.get(0).appendChild(advantagesVideoEl);
    advantagesStickyMain.css('z-index', '-100');

    fetch('https://cdn.jsdelivr.net/gh/eugene-activbody/activeforce_data/advantages_scene/scene_bg.webm')
      .then((res) => res.blob())
      .then((blob) => {
        advantagesVideoEl.src = URL.createObjectURL(blob);
        advantagesVideoEl.load();
      })
      .catch((err) => console.error('Error loading video', err));
  }

  if (!isAdvantagesAnimationInitialized) {
    isAdvantagesAnimationInitialized = true;
    addSectionObserver(advantagesSection, addSequenceAnimation, true, '90%', false);
  }
}

$(window).on('load', function () {
  if (advantagesSection.length) {
    observeAdvantagesGradientPlayback();
    addSectionObserver(advantagesSection, initSquenceAnimation, true, '120%', false);
  }
});

//$(window).on('heroReady', addSequenceAnimation);
